import ErrorBoundary from '@/components/common/ErrorBoundary';
import { FlexRow } from '@/components/common/Flex';
import GoalsChart, {
    GoalsChartEntityParams,
} from '@/components/goals/GoalsChart';
import { FlexProps } from '@chakra-ui/react';
import { TickRange } from '@common/valueSeries';
import { ParentSize } from '@visx/responsive';

interface ChartContainerProps extends FlexProps {
    chartEntities: GoalsChartEntityParams[];
    range: TickRange;
}

const ChartContainer = ({
    chartEntities,
    range,
    ...props
}: ChartContainerProps) => {
    return (
        <FlexRow
            position="absolute"
            h="full"
            w="full"
            align="center"
            justify="center"
            {...props}
        >
            <ParentSize>
                {(parent) => (
                    <ErrorBoundary>
                        <GoalsChart
                            width={parent.width}
                            height={parent.height}
                            range={range}
                            entities={chartEntities}
                        />
                    </ErrorBoundary>
                )}
            </ParentSize>
        </FlexRow>
    );
};

export default ChartContainer;
